import { linkHandler } from '../LinkHandler/LinkHandler';

export type TMenuEntry = { to: string; title: string };

export const MenuEntries: TMenuEntry[] = [
  { to: linkHandler.get('home'), title: 'Home' },
  { to: linkHandler.get('sleepPage'), title: 'Schlaf' },
  { to: linkHandler.get('zppLandingPage'), title: 'Krankenkasse' },
  { to: linkHandler.get('pricing'), title: 'Preise' },
  { to: linkHandler.get('contact'), title: 'Kontakt' },
];
